(function() {
    $(document).ready(function () {

        $('.nav-fixed-scroll').on("click", function () {
            $('.nav-fixed').animate({scrollLeft: 1000}, 800);
        })

        $('.room-list-toggle').on('click', null, function(e){
            $(".room-list__item.hide").removeClass("hide")
            $(this).hide();
            console.log("test")
        });

        if ($(".nav-fixed").length) {
            $(window).scroll(function(){
                if ($(window).scrollTop() >= 140) {
                    $('.nav-fixed').addClass('open');
                }
                else {
                    $('.nav-fixed').removeClass('open');
                }
            });
        }

        $("[data-scroll-to]").on("click", function (e) {
            var offset = $(this).attr("data-offset") ? $(this).attr("data-offset") : 80;

            $("html, body").animate({ scrollTop: $($(this).attr("data-scroll-to")).offset().top - offset }, 500);
            return false
        });


        $(".floor-plane-btn").on("click", function(e){
            e.preventDefault();
            $(".floor-plane-img .first-photo .fancybox").click()
        })


        $('.nav-fixed').scroll(function () {
            var $elem = $('.nav-fixed');
            var newScrollLeft = $elem.scrollLeft(),
              width = $elem.width(),
              scrollWidth = $elem.get(0).scrollWidth;
            var offset = 0;
            if (scrollWidth - newScrollLeft - width === offset) {
                $elem.addClass("end")
            } else {
                $elem.removeClass("end")
            }
        });





        $('.more-link:not(.more-link-translated)').on('click', null, function(event){
            event.preventDefault();
            var itemId = $(this).attr('aria-labelledby');
            $(this).hide();
            $('#'+itemId).slideDown('slow');
        });

		$('.more-link-translated').on('click', null, function(event){
			event.preventDefault();

			$.ajax({
				type: "POST",
				url: Routing.generate("api_translation_translate"),
				data: {
					"from": "nl",
					"to": "fr",
					"text": $('#itemLongDescriptionContent').html()
				},
				dataType: "json",
				success: function (result) {
					$('#itemLongDescriptionContent').html(result);
				}
			});
		});

        /* fancyBox
         ==================================================================================================== */

        if( $(window).width() <= 736) {
            $('.mobile-not-active').click(function(e) {
                e.preventDefault();
            });
        }

        if( $(window).width() > 736) {
            $('.fancybox').fancybox({
                width: "100%",
                margin: [0, 0, 0, 0],
                padding: [0, 0, 0, 0],
                openEffect: 'none',
                closeEffect: 'none',
                prevEffect: 'elastic',
                nextEffect: 'elastic',
                closeBtn: true,
                arrows: true,
                helpers: {
                    title: {
                        // title position options:
                        // 'float', 'inside', 'outside' or 'over'
                        type: 'inside'
                    },
                    overlay: {
                        css: {
                            'background': 'rgba(0, 0, 0, 0.85)'
                        }
                    },
                    buttons: {}

                },
                beforeShow: function () {

                    //if you already have titles
                    //on your fancybox you can append
                    if (this.title) {
                        //set description to current title
                        //this will set what posts
                        var description = this.title;

                        //add pinterest button for title
                        this.title = '<div><a class="fancybox-link-with-pinit-button" href="http://pinterest.com/pin/create/button/?url=' +
                            encodeURIComponent(document.location.href) +
                            '&media=' +
                            //put the path to the image you want to share here
                            encodeURIComponent(this.href) +
                            '&description=' + description + '" class="pin-it-button" count-layout="horizontal">' +
                            '<img border="0" src="//assets.pinterest.com/images/pidgets/pinit_fg_en_rect_red_28.png" title="Pin It" style="margin-right: 10px; margin-left: 8px;"/></a>'
                            //add title information
                            + '<span class="fancybox-title-with-pinit-button">' + this.title + '</span></div>';

                        //if you don't already have titles
                        //you can just make the title the pinterest button
                    } else {
                        //add pinterest button for title
                        this.title = '<a href="http://pinterest.com/pin/create/button/?url=' +
                            encodeURIComponent(document.location.href) +
                            '&media=http%3A%2F%2Fwww.homesburlingtonvermont.com' +
                            encodeURIComponent(this.href) +
                            '&description=Pin from ScottGale.com" class="pin-it-button" count-layout="horizontal">' +
                            '<img border="0" src="https://assets.pinterest.com/images/PinExt.png" title="Pin It" /></a>';

                    }
                },
                afterShow: function () {
                    $('.fancybox-wrap').swipe({
                        swipe: function (event, direction) {
                            if (direction === 'left' || direction === 'up') {
                                $.fancybox.next(direction);
                            } else {
                                $.fancybox.prev(direction);
                            }
                        }
                    });
                },

                afterLoad: function () {
                }
            });
        }
        $('.onload-not-active').each(function() {
            var link = $(this);
            link.attr("href", link.attr("data-href"));
        });
        $('.onload-not-active').removeClass('onload-not-active');

        $('[data-toggle="tooltip"]').tooltip();
    });

})();
